import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import currencyFormatter from "currency-formatter";

import HelpComponent from "../HelpComponent";
import {Badge} from "primereact/badge";

const _FM_ReceiptShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {action, id} = useParams();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const invoiceId = window.App.urlVars().invoiceId ?? id;
    if (!invoiceId) {
      return;
    }

    setLoading(true);
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "invoice/" + invoiceId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setFormData(response.data.data || {});
        setLoading(false);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setLoading(false);
      });
  }, [id, window.App.state.rerenderReceiptList]);

  const formatDate = (dateValue) => {
    if (!dateValue) {
      return '-';
    }
    return moment.utc(dateValue).local().format(t('YYYY-MM-DD HH:mm:ss'));
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) {
      return '-';
    }
    return currencyFormatter.format(Number(value), {
      precision: t('currency_precision'),
      symbol: t('currency_symbol'),
      decimal: t('currency_decimal'),
      thousand: t('currency_thousand'),
    });
  };

  const renderValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    if (typeof value === 'boolean') {
      return value ? t('yes') : t('no');
    }
    if (typeof value === 'object') {
      const objectLabel =
        value.label ||
        value.name ||
        value.code ||
        value.public_id ||
        value.id ||
        value.value;

      if (objectLabel !== null && objectLabel !== undefined && objectLabel !== '') {
        return String(objectLabel);
      }

      return '-';
    }
    return value;
  };

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
            {formData.current_invoice_third_party_id || formData.third_party_service_id || t('receipt_show')}
            <Badge
              value={
                (formData.status || 'draft') === 'draft'
                  ? t('receipt_status_draft')
                  : (formData.status || 'draft') === 'issued'
                    ? (formData.type === 'proforma'
                      ? t('receipt_status_proforma')
                      : t('receipt_status_issued'))
                    : (formData.status || 'draft') === 'cancelled'
                      ? t('receipt_status_cancelled')
                      : t('receipt_status_draft')
              }
              style={{
                marginLeft: '10px',
                position: 'relative',
                top: '-4px',
                backgroundColor:
                  (formData.status || 'draft') === 'draft'
                    ? '#ffb027'
                    : (formData.status || 'draft') === 'issued'
                      ? '#0abb87'
                      : (formData.status || 'draft') === 'cancelled'
                        ? '#ff7f7f'
                        : '#ffb027',
                color: '#fff'
              }}
            />
            {formData.paid_at !== null ? (
              <Badge value={t('paid')} style={{
                backgroundColor: '#0abb87', color: '#fff', position: 'relative',
                top: '-4px'
              }}
                     className={"p-ml-2"}/>
            ) : (
              <Badge value={t('unpaid')} style={{
                backgroundColor: '#ffb027', color: '#fff', position: 'relative',
                top: '-4px'
              }}
                     className={"p-ml-2"}/>
            )}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          {formData.status === 'draft' &&
            <Button type="button" aria-label={t('edit')}
                    icon={"pi pi-pencil"}
                    loading={loading}
                    onClick={() => {
                      if (formData?.id) {
                        navigate('/receipt/update/' + formData.id);
                      }
                    }}
                    className="p-button-warning p-ml-2">
            </Button>
          }
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formatDate(formData.created_at_snapshot)}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {formatDate(formData.updated_at_snapshot)}
          </p>
        </div>
      </div>
      <HelpComponent type={"show_box"}/>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="">{t('reservation') + " / " + t('customer')}</label>
              <span className="p-d-block p-text-bold">
                {formData?.customer?.id &&
                  <>
                    <i className={"pi pi-window-maximize"}
                       onClick={(e) => {
                         e.stopPropagation();
                         navigate('/receipt/' + action + '/' + id + '?read=customer&customerId=' + formData?.customer?.id)
                       }}
                    ></i>
                    &nbsp;
                    {formData?.customer?.firstname} {formData?.customer?.lastname}
                  </>
                }
                {formData?.reservation_group?.id &&
                  <>
                    <i className={"pi pi-window-maximize"}
                       onClick={(e) => {
                         e.stopPropagation();
                         navigate('/receipt/' + action + '/' + id + '?read=reservationGroup&reservationGroupId=' + formData.reservation_group?.id)
                       }}
                    ></i>
                    &nbsp;
                    {formData.reservation_group?.public_id?.toUpperCase()}
                  </>
                }
                {!formData?.customer?.id && !formData?.reservation_group?.id && '-'}
              </span>
            </div>
          </div>
          {/*<div className={"p-col-12 p-lg-3"}>*/}
          {/*  <div className="p-field p-fluid">*/}
          {/*    <label htmlFor="customer">{t('customer')}</label>*/}
          {/*    <span className="p-d-block p-text-bold">*/}
          {/*      {renderValue(*/}
          {/*        formData?.customer?.firstname || formData?.customer?.lastname*/}
          {/*          ? ((formData?.customer?.lastname || '') + ' ' + (formData?.customer?.firstname || '')).trim()*/}
          {/*          : formData?.customer?.name || formData.customer*/}
          {/*      )}*/}
          {/*    </span>*/}
          {/*  </div>*/}
          {/*</div>*/}
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="type">{t('type')}</label>
              <span className="p-d-block p-text-bold">{renderValue(formData.type ? t(formData.type) : null)}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="language">{t('language')}</label>
              <span
                className="p-d-block p-text-bold">{renderValue(formData.language ? formData.language.toUpperCase() : null)}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="payment_method">{t('payment_method')}</label>
              <span className="p-d-block p-text-bold">
                {renderValue(
                  formData?.payment_method?.name
                    ? window.App.getTranslatedLabel(formData.payment_method.name)?.replaceAll('_', ' ')
                    : formData?.payment_method?.label || formData.payment_method
                )}
              </span>
            </div>
          </div>

          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="currency">{t('currency')}</label>
              <span
                className="p-d-block p-text-bold">{renderValue(formData?.currency?.code || formData.currency)}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="issued_at">{t('issued_at')}</label>
              <span className="p-d-block p-text-bold">{formatDate(formData.issued_at)}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="fulfillment_date">{t('fulfillment_date')}</label>
              <span className="p-d-block p-text-bold">{formatDate(formData.fulfillment_date)}</span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="payment_due_at">{t('payment_due_at')}</label>
              <span className="p-d-block p-text-bold">{formatDate(formData.payment_due_at)}</span>
            </div>
          </div>
        </div>
      </Panel>

      <Panel className={"p-mt-3"}>
        <div className={"p-grid col-borders"}>
          <div className={"p-col-12 p-lg-6 col-border-right"}>
            <h3 className={"p-mt-0"}>{t('seller')}</h3>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4"}>
                <div className="p-field p-fluid">
                  <label htmlFor="seller_name">{t('name')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.seller_name)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="seller_country_code">{t('country')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.seller_country_code)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="seller_zip">{t('zip_code')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.seller_zip)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="seller_city">{t('city')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.seller_city)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="seller_tax_number">{t('tax_number')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.seller_tax_number)}</span>
                </div>
              </div>
              <div className={"p-col-12"}>
                <div className="p-field p-fluid">
                  <label htmlFor="seller_address_line1">{t('address')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.seller_address_line1)}</span>
                </div>
              </div>
            </div>
          </div>
          <div className={"p-col-12 p-lg-6 col-border-left"}>
            <h3 className={"p-mt-0"}>{t('buyer')}</h3>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_name">{t('name')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.buyer_name)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_type_enum">{t('buyer_type')}</label>
                  <span
                    className="p-d-block p-text-bold">{renderValue(formData.buyer_type_enum ? t(formData.buyer_type_enum) : null)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_country_code">{t('country')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.buyer_country_code)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_zip">{t('zip_code')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.buyer_zip)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_city">{t('city')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.buyer_city)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_address_line1">{t('address')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.buyer_address_line1)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-3"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_email">{t('email')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.buyer_email)}</span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-3"}>
                <div className="p-field p-fluid">
                  <label htmlFor="buyer_tax_number">{t('tax_number')}</label>
                  <span className="p-d-block p-text-bold">{renderValue(formData.buyer_tax_number)}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Panel>

      <Panel className={"p-mt-3"}>
        <h3 className={"p-mt-0"}>{t('receipt_items')}</h3>
        <table className={"w-100 p-datatable-table table-striped"} cellPadding={0} cellSpacing={0} border={0}>
          <thead>
          <tr>
            <th className={"p-p-2 p-text-left"}>{t('name')}</th>
            <th className={"p-p-2 p-text-right"}>{t('quantity')}</th>
            <th className={"p-p-2 p-text-left"}>{t('unit')}</th>
            <th className={"p-p-2 p-text-right"}>{t('unit_net_amount')}</th>
            <th className={"p-p-2 p-text-left"}>{t('vat_percent')}</th>
            <th className={"p-p-2 p-text-right"}>{t('net_amount')}</th>
            <th className={"p-p-2 p-text-right"}>{t('tot_price')}</th>
          </tr>
          </thead>
          <tbody>
          {Array.isArray(formData.items) && formData.items.length > 0 ? (
            formData.items.map((item, index) => {
              const netAmount = item.net_amount || Number(item.unit_net_amount || 0) * Number(item.quantity || 0);
              const grossAmount = item.gross_amount || (netAmount * (1 + Number(item.vat_percent || 0) / 100));
              return (
                <tr key={item.id || index}>
                  <td className={"p-text-left"}>{renderValue(item.name)}</td>
                  <td className={"p-text-right"}>{renderValue(item.quantity)}</td>
                  <td className={"p-text-left"}>{renderValue(item.unit ? t(item.unit) : null)}</td>
                  <td
                    className={"p-text-right"}>{formatCurrency(item.unit_net_amount)} {renderValue(formData?.currency?.code || formData.currency)}</td>
                  <td className={"p-text-left"}>{renderValue(item.vat_percent)} %</td>
                  <td
                    className={"p-text-right"}>{formatCurrency(netAmount)} {renderValue(formData?.currency?.code || formData.currency)}</td>
                  <td
                    className={"p-text-right p-text-bold"}>{formatCurrency(grossAmount)} {renderValue(formData?.currency?.code || formData.currency)}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={7}>{t('empty_message')}</td>
            </tr>
          )}
          </tbody>
        </table>
      </Panel>
    </>
  );
}

export default withTranslation('common')(_FM_ReceiptShowComponent);
